function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var RewardsFilled = function RewardsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M7.206 1.904c1.007-.805 2.679-.642 3.668.85.46.69.834 1.402 1.126 2.047.292-.645.667-1.356 1.126-2.048.989-1.491 2.661-1.654 3.668-.849l.053.047c.53.511.769 1.1.76 1.695-.009.567-.24 1.054-.489 1.409-.224.32-.593.588-.937.803-.21.132-.445.263-.692.392H19A2.75 2.75 0 0 1 21.75 9v10A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19V9A2.75 2.75 0 0 1 5 6.25h3.511c-.247-.129-.481-.26-.692-.392-.344-.215-.713-.483-.937-.803-.248-.355-.48-.842-.489-1.409-.009-.595.23-1.184.76-1.695zm.961 1.153c-.235.239-.276.43-.274.567.003.17.077.37.218.57.038.056.181.192.503.392.298.187.68.387 1.108.592.327.156.669.31 1.008.458-.271-.625-.64-1.35-1.106-2.054-.533-.804-1.187-.715-1.457-.525m7.94.567c.002-.137-.039-.328-.274-.567-.27-.19-.924-.28-1.457.525a13.4 13.4 0 0 0-1.105 2.054c.338-.148.68-.302 1.007-.458.428-.205.81-.405 1.108-.592.322-.2.465-.336.503-.391.141-.202.215-.4.218-.571M12.75 8.5a.75.75 0 0 0-1.5 0v4.75H4.5a.75.75 0 0 0 0 1.5h6.75v4.75a.75.75 0 0 0 1.5 0v-4.75h6.75a.75.75 0 0 0 0-1.5h-6.75z",
    clipRule: "evenodd"
  }));
};
export default RewardsFilled;
RewardsFilled.displayName = 'RewardsFilled';